import { FunctionComponent, useEffect, useState } from 'react';

import { ItemLabelModel } from '../../../features/shared/components/dropdown/models/dropdown-props.model';
import { useAppDispatch } from '../../../store/hooks';
import { WithOptionsParamsModel } from './models/with-options-params.model';
import { WithOptionsModel } from './models/with-options.model';

export const withOptions = <
  TDtoType,
  TProps extends WithOptionsModel,
  TThunkArgs = void
>(
  Component: FunctionComponent<TProps>,
  {
    dispatchFn,
    mapper,
    thunkArgs,
  }: WithOptionsParamsModel<TDtoType, TThunkArgs>
): FunctionComponent<Omit<TProps, 'options'>> => {
  return (props: Omit<TProps, 'options'>) => {
    const [options, setOptions] = useState<ItemLabelModel[]>([]);
    const dispatch = useAppDispatch();

    useEffect(() => {
      const dispatcher = dispatch(dispatchFn(mapper)(thunkArgs));

      dispatcher
        .unwrap()
        .then(result => setOptions(result))
        .catch(error => {
          if (error.name === 'AbortError') {
            return;
          }
        });

      return () => {
        dispatcher.abort();
      };
    }, [thunkArgs]);

    return <Component {...(props as TProps)} options={options} />;
  };
};
